import React, { useState } from 'react';

const JobSeekerSignup = () => {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        username: '',
        password: '',
        gender: '',
        veteranStatus: '',
        workVisaStatus: '',
        otherVisaDetails: '',
        linkedin: '',
        portfolio: '',
        resume: null,
        workStatus: '',
        disability: '',
    });

    const genders = ['Male', 'Female', 'Non-Binary', 'Prefer not to say'];
    const veteranStatuses = ['Veteran', 'Non-Veteran', 'Prefer not to say'];
    const visaStatuses = [
        'U.S. Citizen',
        'Work VISA',
        'Student VISA',
        'Permanent Resident',
        'Other',
    ];
    const employmentStatuses = ['Employed', 'Unemployed', 'Student', 'Self-Employed', 'Prefer not to say'];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, resume: e.target.files[0] });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formDataToSend = new FormData();
            Object.keys(formData).forEach((key) => {
                formDataToSend.append(key, formData[key]);
            });

            const response = await fetch('http://127.0.0.1:5000/jobseekers/signup', {
                method: 'POST',
                body: formDataToSend,
            });

            if (response.ok) {
                alert('Profile created successfully!');
                setFormData({
                    fullName: '',
                    email: '',
                    phone: '',
                    username: '',
                    password: '',
                    gender: '',
                    veteranStatus: '',
                    workVisaStatus: '',
                    otherVisaDetails: '',
                    linkedin: '',
                    portfolio: '',
                    resume: null,
                    workStatus: '',
                    disability: '',
                });
            } else {
                alert('Failed to create profile. Please try again.');
            }
        } catch (err) {
            console.error('Error submitting form:', err);
            alert('An error occurred. Please try again later.');
        }
    };

    return (
        <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
            <h2>Job Seeker Sign-Up</h2>
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '15px' }}>
                    <label>Full Name:</label>
                    <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Email:</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Phone:</label>
                    <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Username:</label>
                    <input
                        type="text"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Password:</label>
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Gender:</label>
                    <select
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    >
                        <option value="">-- Select Gender --</option>
                        {genders.map((gender, index) => (
                            <option key={index} value={gender}>
                                {gender}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Veteran Status:</label>
                    <select
                        name="veteranStatus"
                        value={formData.veteranStatus}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    >
                        <option value="">-- Select Veteran Status --</option>
                        {veteranStatuses.map((status, index) => (
                            <option key={index} value={status}>
                                {status}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Work VISA/Citizenship Status:</label>
                    <select
                        name="workVisaStatus"
                        value={formData.workVisaStatus}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    >
                        <option value="">-- Select Status --</option>
                        {visaStatuses.map((status, index) => (
                            <option key={index} value={status}>
                                {status}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Current Employment Status:</label>
                    <select
                        name="workStatus"
                        value={formData.workStatus}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    >
                        <option value="">-- Select Status --</option>
                        {employmentStatuses.map((status, index) => (
                            <option key={index} value={status}>
                                {status}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Disability (Optional):</label>
                    <textarea
                        name="disability"
                        value={formData.disability}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Upload Resume:</label>
                    <input
                        type="file"
                        name="resume"
                        accept=".pdf,.doc,.docx"
                        onChange={handleFileChange}
                        required
                        style={{ marginTop: '5px' }}
                    />
                </div>
                <button
                    type="submit"
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#007BFF',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Create Profile
                </button>
            </form>
        </div>
    );
};

export default JobSeekerSignup;

